<template>
  <div class="col-12">
    <div class="about-settings">
      <form class="about-form">
        <div class="form-group row">
          <label for="version" class="form-label col-4 col-sm-2 col-form-label">Version</label>
          <input
            type="text"
            id="version"
            placeholder="GSSC Now x.x.x"
            v-model="about.version"
            class="form-text col-8 col-sm-10"
          />
          <!-- <label for="copyright" class=" form-label col-4 col-sm-2 col-form-label">Copyright</label>
          <input
            type="text"
            id="copyright"
            placeholder="© European Space Agency, 2019, 2020, 2021, 2022."
            v-model="about.copyright"
            class="form-text col-8 col-sm-10"
          />
          <label for="boldtext" class=" form-label col-4 col-sm-2 col-form-label">Bold Text</label>
          <textarea
            id="boldtext"
            class="form-text col-8 col-sm-10"
            placeholder="GSSC is ESA GNSS Science Support Centre Exploitation Platform."
            v-model="about.boldtext"
          ></textarea> -->
          <label for="maintext" class=" form-label col-4 col-sm-2 col-form-label">Main Text</label>
          <textarea
            id="maintext"
            class="form-text col-8 col-sm-10"
            rows="4"
            placeholder="The purpose of GSSC is to support collaboration and research across scientific communities through the provision of science-based information products and services regarding GNSS Infrastructures."
            v-model="about.text"
          ></textarea>
        </div>
      </form>
    </div>
    <button class="about-settings__saveBtn btn btn-primary" @click.prevent="saveAbout">Save</button>
    <span v-if="result" class="about-settings__resultsAlert alert alert-primary" role="alert">{{ result }}</span>
  </div>
</template>

<script>
import * as api from '@/lib/api'
export default {
  data() {
    return {
      about: {
        version: '',
        text: '',
        // copyright: '',
        // boldtext: '',
        // plaintext: '',
      },
      result: '',
    }
  },
  methods: {
    async loadAbout() {
      const response = await api.getAbout()
      this.about = response
      console.log('about settings', { response })
    },
    async saveAbout() {
      this.result = 'About saved'
      setTimeout(() => (this.result = ''), 1000)
      const response = await api.saveAbout(this.about)
      console.log(response)
    },
  },
  mounted() {
    this.loadAbout()
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/globals';
.about-settings {
  padding: 20px 30px 18px;
  background: white;
  border-top: 8px solid $pure-teal;
  margin-bottom: 1rem;
  form {
    padding: 10px 24px;
    border-bottom: 1px solid $pure-teal;
  }
  &__saveBtn {
    margin-right: 1rem;
  }
  &__resultsAlert {
    display: inline-block;
    margin-left: 20px;
    padding: 8px;
  }
}
</style>
